import { BgisSearch, BgisSearchBody, BgisSearchHeader } from "../../bgis/components/maparea/sidebar/menus/search";
import { BgisButtonIcon } from "../../bgis/components/icon";
import { toggleClass } from "../../bgis/util/dom";
import { useAppDispatch, useAppSelector } from "../hooks";
import { searchByQuery, setQuery } from '../redux/slice/searchSlice';
import { ChangeEvent  } from "react";
import { debounce } from 'debounce';

export const Search = ( ) => {

  // Stores the content of the search field.   
  const query = useAppSelector(state => state.search.query);

  const dispatch = useAppDispatch();

  const handleSearchRequest = (query: string) => dispatch(searchByQuery(query));

  const debouncedSearchRequest = debounce(handleSearchRequest, 500);


  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(setQuery(event.target.value));
    debouncedSearchRequest(event.target.value);
  }


  return (<BgisSearch>
    <BgisSearchHeader>
      <BgisButtonIcon iconName='bgis-icon-bars' onClick={() => { }} />
      <input
        id='h2o-webgis-search'
        className="bgis-grow bgis-subtitle1"
        type="search"
        placeholder="durchsuchen ..."
        title="Suchen nach&#13;
        x Grundstück (Katastralgemeindekode Grundstücksnummer)&#13;     Beispiel: 12114 3515&#13; 
        x Adresse (Straße Hausnummer Postleitzahl Gemeinde)&#13;     Beispiel: Schulgasse 1&#13;&#13;ist möglich"
        value={query} //onChange triggers debounced the search (in order to avoid to many unecessary server requests)
        onChange={(event) => onChange(event)}  // 
      />
      </BgisSearchHeader>
    <BgisSearchBody>
      filter

    </BgisSearchBody>
  </BgisSearch>);
}


